module.exports = __webpack_public_path__ + "static/media/1021465.ebedfd8b.jpg";